import React from 'react';
import { Link } from 'react-router-dom';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend
);

const CategoryBreakdown = ({ data, year }) => {
  if (!data || data.length === 0) {
    return (
      <div className="d-flex align-items-center justify-content-center h-100">
        <p className="text-muted">No category data available</p>
      </div>
    );
  }

  const sortedData = [...data].sort((a, b) => b.amount - a.amount);
  const topCategories = sortedData.slice(0, 5);
  const otherCategories = sortedData.slice(5);

  let finalData = [...topCategories];
  if (otherCategories.length > 0) {
    const otherSum = otherCategories.reduce((acc, curr) => acc + curr.amount, 0);
    finalData.push({
      name: 'Other',
      amount: otherSum,
      color: '#9E9E9E',
      id: null,
    });
  }

  const chartData = {
    labels: finalData.map((cat) => cat.name),
    datasets: [
      {
        data: finalData.map((cat) => cat.amount),
        backgroundColor: finalData.map((cat) => cat.color || '#9E9E9E'),
        borderColor: finalData.map((cat) =>
          cat.color
            ? cat.color.replace(')', ', 0.9)').replace('rgb', 'rgba')
            : 'rgba(158, 158, 158, 0.9)'
        ),
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 12,
          padding: 15,
        },
      },
      tooltip: {
        callbacks: {
          label(context) {
            const label = context.label || '';
            const value = context.raw || 0;
            const total = context.dataset.data.reduce((acc, curr) => acc + curr, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            return `${label}: £${value.toFixed(2)} (${percentage}%)`;
          },
        },
      },
    },
    cutout: '65%',
  };

  const drillYear = year || new Date().getFullYear();
  const linkable = sortedData.filter((cat) => cat.id != null).slice(0, 5);

  return (
    <div>
      <div style={{ height: '260px' }}>
        <Doughnut data={chartData} options={options} />
      </div>
      {linkable.length > 0 && (
        <ul className="category-leaderboard mt-3 mb-0">
          {linkable.map((cat) => (
            <li key={cat.id}>
              <Link to={`/analysis/categories/${cat.id}?year=${drillYear}`}>{cat.name}</Link>
              <strong>£{(cat.amount || 0).toFixed(2)}</strong>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CategoryBreakdown;
